'use client';

import { lazy, Suspense, useState, type ReactElement } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { useDeferredUnmount } from '@/hooks/use-deferred-unmount';

const NotifyMeDialog = lazy(() => import('./notify-me-dialog').then((module) => ({ default: module.NotifyMeDialog })));

export type NotifyMeTriggerProps = {
    productId: string;
    /** The CTA; its own onClick still runs before the dialog opens. */
    children: ReactElement;
};

/** Wraps a CTA so clicking it opens the lazily loaded Notify Me dialog for `productId`. */
export const NotifyMeTrigger = ({ productId, children }: NotifyMeTriggerProps) => {
    const [open, setOpen] = useState(false);
    const mounted = useDeferredUnmount(open);

    return (
        <>
            <Slot aria-haspopup="dialog" onClick={() => setOpen(true)}>
                {children}
            </Slot>
            {mounted && (
                <Suspense fallback={null}>
                    <NotifyMeDialog open={open} onOpenChange={setOpen} productId={productId} />
                </Suspense>
            )}
        </>
    );
};
